<template>
  <div>
    <vxe-grid
      ref="listingTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      cell-class-name="align-top"
      resizable
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:sellType="{ row }">
        <el-tag
          v-if="row.v_sellType"
          size="mini"
          :type="
            row.sellType === 'B'
              ? ''
              : row.sellType === 'C'
              ? 'warning'
              : 'success'
          "
        >
          {{ row.v_sellType || '未配置' }}
        </el-tag>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.storeSkuStatus === 'Y'
              ? 'success'
              : row.storeSkuStatus === 'S' ||
                row.storeSkuStatus === 'B' ||
                row.storeSkuStatus === 'W'
              ? 'danger'
              : row.storeSkuStatus === 'X'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_storeSkuStatus || '未配置状态' }}
        </el-tag>
      </template>
      <template v-slot:defaultImageUrl="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:fbaInvQty="{ row }">
        <div>
          <div style="display: flex;justify-items: center;align-items: center;">
            <div style="flex: 1;">
              <span>{{ $l('table_label_sellableDays') || '可售天数' }}：</span
              ><span>{{ row.sellableDays }}</span>
            </div>
            <div class="tag">
              <span
                class="animate-ping tag-sapn absolute"
                :style="{ backgroundColor: row.alertLevelColor }"
              ></span>
              <span
                class="tag-sapn relative"
                :style="{ backgroundColor: row.alertLevelColor }"
              ></span>
            </div>
          </div>
          <span>{{ $l('table_label_fbaInvQty') || '库存数量' }}：</span
          ><span>{{ row.fbaInvQty }}</span>
          <br />
          <span>{{ $l('table_label_salesVolume7d') || '七日销售量' }}：</span
          ><span>{{ row.salesVolume7d }}</span>
          <br />
          <span
            >{{
              $l('table_label_avgSalesVolume7d') || '七日平均销售量'
            }}：</span
          ><span>{{ row.avgSalesVolume7d }}</span>
          <br />
          <span>{{ $l('form_label_monitorPeriod') || '监控周期' }}：</span
          ><span style="color: #303133">{{ row.monitorPeriod }}</span>
        </div>
      </template>
      <template v-slot:displayName="{ row }">
        <span>SKU：</span>
        <span style="color: #303133">{{ row.amzGoodsSkuNo }}</span>
        <br />
        <span>{{ row.brandName }}</span>
        <br />
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
        <br />
        <span>SPU：</span>
        <span style="color: #303133">{{ row.amzSpuNo }}</span>
        <br />
        <span>{{ row.collectionName }}</span>
        <br />
        <span>{{ row.englishSize }}</span>
        <br v-if="row.isFocus == 'Y'" />
        <el-tag
          type="warning"
          effect="plain"
          size="mini"
          v-if="row.isFocus == 'Y'"
        >
          {{ $l('table_text_isFocus') || '重点关注' }}
        </el-tag>
      </template>
      <template v-slot:displayFactory="{ row }">
        <span>NC：{{ row.ncNo }}</span>
        <br />
        <span>{{ row.scmName }}</span>
      </template>
      <template v-slot:displaySalesTitle="{ row }">
        <span>{{ row.salesTitle }}</span>
        <br />
        <span>SKU：</span><span style="color: #303133">{{ row.amzSkuNo }}</span>
        <br />
        <span>ASIN：</span
        ><span style="color: #409EFF">{{ row.asinCode }}</span>
        <br />
        <span>FNSKU：</span
        ><span style="color: #409EFF">{{ row.fnskuCode }}</span>
      </template>
      <template v-slot:displayStore="{ row }">
        <span>SHOP：</span
        ><span style="color: #303133">{{ row.amzStoreName }}</span>
        <br />
        <span>BRAND：</span
        ><span style="color: #303133">{{ row.storeBrandName }}</span>
        <br />
        <div>
          <span>METHOD：</span>
          <el-tag
            v-if="row.v_sellType"
            size="mini"
            :type="
              row.sellType === 'B'
                ? ''
                : row.sellType === 'C'
                ? 'warning'
                : 'success'
            "
          >
            {{ row.v_sellType || '未配置' }}
          </el-tag>
        </div>
        <div>
          <span>STATUS：</span>
          <el-tag
            size="mini"
            :type="
              row.storeSkuStatus === 'Y'
                ? 'success'
                : row.storeSkuStatus === 'S' ||
                  row.storeSkuStatus === 'B' ||
                  row.storeSkuStatus === 'W'
                ? 'danger'
                : row.storeSkuStatus === 'X'
                ? 'warning'
                : ''
            "
          >
            {{ row.v_storeSkuStatus || '未配置状态' }}
          </el-tag>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    onCheckboxChange({ records }) {
      this.$emit('checkboxChange', records)
    },
  },
}
</script>
<style lang="scss" scoped>
@keyframes ping {
  75%,
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1.5s cubic-bezier(0, 0, 0.1, 0.6) infinite;
}
.tag {
  position: relative;
  display: inline-flex;
  justify-content: center;
  flex: 1;
}
.tag-sapn {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  opacity: 0.75;
  display: inline-flex;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
</style>
